var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptimizelyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logosandtypes_com",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill:#0037ff}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer_3",
    d: "M0 0h150v150H0V0z",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Optimizely"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M126.6 22.8C108 4.3 77.7 4.3 59.2 23.2c-6.1 6.1-10.1 13.3-12.1 21.4-8.1 2-15.3 6.1-21.4 12.1-9.3 9.3-14.1 21.4-14.1 33.5l33.9-33.9c0 2.8.4 6.1.8 8.9L12.4 99.1c.8 4.8 2.4 9.7 4.8 14.1L39 91.4c-.4-5.7 1.6-11.3 6.1-15.3 1.2-1.2 2-2 3.2-2.8 2.4 6.5 6.1 12.1 10.9 17.4 4.8 4.8 10.9 8.9 17.4 10.9-.8 1.2-1.6 2.4-2.8 3.2-4.4 4.4-10.1 6.1-15.3 6.1l-21.8 21.8c4.4 2.4 9.3 4 14.1 4.8l33.9-33.9c2.8.4 6.1.8 8.9.8l-33.9 33.9c12.1 0 24.2-4.8 33.1-14.1 6.1-6.1 10.1-13.7 12.5-21.4 7.7-2 15.3-6.1 21.4-12.5 18.4-18.6 18.4-48.9-.1-67.5zm-19 48.5c-8.1 8.1-21 8.1-28.7 0-7.7-8.1-8.1-21 0-28.7 8.1-8.1 21-8.1 28.7 0 7.7 8.1 7.7 20.6 0 28.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.7 105.2c-1.6-1.6-2.8-3.6-4-5.7l-19.8 19.8c1.2 1.6 2.8 3.6 4.4 5.2 1.6 1.6 3.2 3.2 5.2 4.4l19.8-19.8c-2-1.1-3.6-2.3-5.6-3.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptimizelyLogo);
export default __webpack_public_path__ + "static/media/Optimizely-logo.238aa1bba79e40dd962c360b38bcdbd6.svg";
export { ForwardRef as ReactComponent };